<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
                <app-i18n code="home.menu"></app-i18n>
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/property/list' }">
                <app-i18n code="entities.property.menu"></app-i18n>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
                <app-i18n code="entities.property.view.title"></app-i18n>
            </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="app-content-page">
            <h1 class="app-content-title app-content-title--hidden">
                <app-i18n code="entities.property.view.title"></app-i18n>
            </h1>

            <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

            <app-property-view-toolbar v-if="record"></app-property-view-toolbar>

            <el-form
                :label-position="labelPosition"
                :label-width="labelWidthForm"
                @submit.prevent.native
                class="form"
                v-if="record"
            >
                <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

                <app-view-item-text :label="fields.name.label" :value="presenter(record, 'name')"></app-view-item-text>

                <app-view-item-text :label="fields.sport.label" :value="presenter(record, 'sport')"></app-view-item-text>

                <app-view-item-relation-to-many
                    :label="fields.managers.label"
                    :permission="fields.managers.readPermission"
                    :url="fields.managers.viewUrl"
                    :value="presenter(record, 'managers')"
                ></app-view-item-relation-to-many>

                <app-view-item-image
                    :label="fields.logos.label"
                    :value="presenter(record, 'logos')"
                ></app-view-item-image>

                <app-view-item-custom
                    :label="fields.status.label"
                    :value="presenter(record, 'status')"
                >
                    <el-tag
                        :type="propertyStatusTagType(record['status'])"
                    >{{ presenter(record, 'status') }}</el-tag>
                </app-view-item-custom>

                <app-view-item-text
                    :label="fields.createdAt.label"
                    :value="presenter(record, 'createdAt')"
                ></app-view-item-text>

                <app-view-item-text
                    :label="fields.updatedAt.label"
                    :value="presenter(record, 'updatedAt')"
                ></app-view-item-text>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PropertyViewToolbar from '@modules/property/components/property-view-toolbar.vue';
import { PropertyModel } from '@modules/property/property-model';
import { propertyStatusTagType } from '@modules/property/property-enum-status';
import { propertyAccessTagType } from '@modules/property/property-enum-access';

const { fields } = PropertyModel;

export default {
    name: 'app-property-view-page',

    props: ['id'],

    components: {
        [PropertyViewToolbar.name]: PropertyViewToolbar,
    },

    computed: {
        ...mapGetters({
            labelPosition: 'layout/labelPosition',
            labelWidthForm: 'layout/labelWidthForm',
            record: 'property/view/record',
            loading: 'property/view/loading',
        }),

        fields() {
            return fields;
        },
    },

    async created() {
        await this.doFind(this.id);
    },

    methods: {
        ...mapActions({
            doFind: 'property/view/doFind',
        }),

        presenter(record, fieldName) {
            return PropertyModel.presenter(
                record,
                fieldName,
            );
        },

        propertyStatusTagType(status) {
            return propertyStatusTagType(status);
        },

        propertyAccessTagType(status) {
            return propertyAccessTagType(status);
        },
    },
};
</script>
